module.exports = __webpack_public_path__ + "908e4d2e/img/link-icon.fa09ed66.svg";